import { useMemo } from 'react'

import { AUTH_CLAIMS, useAuthorization } from '@apps-common/lib'

export const useIsManagement = () => {
  const { checkAccess } = useAuthorization()

  const isManagement = useMemo(() => {
    let isValid = false

    isValid = checkAccess({ roles: AUTH_CLAIMS.managementUser.roles || [], scopes: AUTH_CLAIMS.managementUser.scopes || [] })

    if (isValid) {
      return isValid
    }

    isValid = checkAccess({ roles: AUTH_CLAIMS.managementAdmin.roles || [], scopes: AUTH_CLAIMS.managementAdmin.scopes || [] })

    return isValid
  }, [])

  return { isManagement }
}
